<template>
  <div class="cast-result">
    <div v-if="isCasted" class="is-casted">
      <h3>Transaction created:</h3>
      <a :href="'https://etherscan.io/tx/' + web3Transaction"><h5>{{ web3Transaction }}</h5></a>
      <div v-if="checkCastResult">
        <table class="table"><tbody><tr><th>key</th><th>value</th></tr>
          <tr><td>file sha256</td><td>{{ contractArgs.sha256 }}</td></tr>
          <tr><td>description</td><td>{{ checkCastResult._description}}</td></tr>
          <tr><td>cast_creator</td><td>{{ checkCastResult._cast_creator }}</td></tr>
          <tr><td>cast_owner</td><td>{{ checkCastResult._cast_owner }}</td></tr>
        </tbody></table>
      </div>
    </div>
    <div v-else>
      <h3>Something went wrong...</h3>
      <h5>{{ web3Error }}</h5>
    </div>
  </div>
</template>

<script>
  import Vue               from 'vue'
  import { mapActions
         , mapGetters
         , mapState      } from 'vuex'

  export default {
    name: "CastLauncher"
  , data () {
      return {
        fileCount: 0
      , description: null
      , error: null
      , timer: null
      , timerCounter: 0
      }
    }
  , components: {}
  , computed: {
      ...mapGetters(['isPrepared'])
    , ...mapGetters(['isCasted', 'isCastError'])
    , ...mapState(['uploadedFiles', 'contractArgs', 'web3Error', 'web3Transaction'])
    , ...mapState(['checkCastResult'])
    }
  , methods: {
      ...mapActions(['checkCast'])
    , checkCurrentTransaction() {
        this.timerCounter = this.timerCounter + 1
        console.log('checkCurrentTransaction', this.timerCounter)
        if (0 < Object.keys(this.checkCastResult || {}).length) {
          clearInterval(this.timer)
          this.timer = null
        } else {
          return this.checkCast( this.contractArgs.sha256 )
        }
      }
    }
  , mounted() {
      if (0 == this.uploadedFiles.length) {
        this.$router.push({ name: 'Dropzone' })
      } else if( this.isCasted ) {
        this.timerCounter = 0
        this.timer = setInterval(this.checkCurrentTransaction, 5000)
      }
    }
  , unmounted() {
      if( this.timer ) clearInterval(this.timer)
    }
  }
</script>

<style lang="scss" scoped>
  .cast-result {
  }
</style>



// WEBPACK FOOTER //
// src/components/caster/CastResult.vue